import {Injectable} from "@angular/core";
import {HandlerError, HttpErrorHandlerService} from "../../../core/services/http-error-handler.service";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {NovoAtendimento} from "../models/novo-atendimento";
import {catchError, Observable} from "rxjs";
import {BaseResponse} from "../../../core/models/base-response";
import {ListaAtendimento} from "../models/lista-atendimento";
import {DetalhesAtendimento} from "../models/detalhes-atendimento";

@Injectable({
  providedIn: 'root'
})
export class AtendimentoService {
  private handlerErro: HandlerError;

  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService) {
    this.handlerErro = httpErrorHandler.createHandleError(`AtendimentoService`);
  }

  baseUrl = environment.apiUrl;

  selecionarLista(): Observable<BaseResponse<ListaAtendimento> | BaseResponse<any>> {
    return this.http
      .get<BaseResponse<ListaAtendimento>>(`${this.baseUrl}/Atendimento`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionar')))
  }

  selecionarPorId(id: number): Observable<BaseResponse<DetalhesAtendimento> | BaseResponse<any> >{
    return this.http
      .get<BaseResponse<DetalhesAtendimento>>(`${this.baseUrl}/Atendimento/${id}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarPorId')));
  }

  selecionarPorPessoaId(id: number): Observable<BaseResponse<DetalhesAtendimento> | BaseResponse<any> >{
    return this.http
      .get<BaseResponse<DetalhesAtendimento>>(`${this.baseUrl}/Atendimento/SelecionarPorPessoaId/${id}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarPorPessoaId')));
  }

  adicionar(request: NovoAtendimento): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    return this.http
      .post<BaseResponse<boolean>>(`${this.baseUrl}/Atendimento`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>(`adicionar`)));
  }

  alterar(request: DetalhesAtendimento): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    return this.http
      .put<BaseResponse<boolean>>(`${this.baseUrl}/Atendimento`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>(`alterar`)));
  }
}
